import script from "./logCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./logCard.vue?vue&type=script&setup=true&lang=ts"

import "./logCard.vue?vue&type=style&index=0&id=63ee3eba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ee3eba"]])

export default __exports__